import { orderFilterOptions, shipmentGridFilters } from './options';
import { Store } from './options/store';
import { SellerBrand } from './options/seller-brand';
import { Destination } from './options/destination';
import { AssignedTo } from './options/assigned-to';
import { Tag } from './options/tag';
import { AllocationStatus } from './options/allocation-status';
import { OrderDate } from './options/order-date';

const popularOrdersFiltersIds = ['store', 'company-name', 'destination', 'assignedTo', 'tag', 'allocationStatus', 'orderDate'];

export const popularFilterByOptions = [Store, SellerBrand, Destination, AssignedTo, Tag, AllocationStatus, OrderDate];

export const otherFilterByOptions = orderFilterOptions.filter(
  (option) => !popularOrdersFiltersIds.includes(option.id) && !shipmentGridFilters.includes(option),
);
